/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export const ShowCurrentReleaseNotesActionId = 'update.showCurrentReleaseNotes';
export const CheckForVSCodeUpdateActionId = 'update.checkForVSCodeUpdate';